/**
 * Detects if a string is fully capitalized (all letters are uppercase)
 * @param {string} text - The text to check
 * @returns {boolean} - True if the text is fully capitalized
 */
const isFullyCapitalized = (text) => {
  // Remove any non-letter characters and check if all remaining letters are uppercase
  const letters = text.replace(/[^a-zA-Z]/g, '');
  return letters.length > 0 && letters === letters.toUpperCase();
};

/**
 * Processes text content to style capitalized words
 * @param {string|React.ReactNode} content - The content to process
 * @returns {React.ReactNode} - The processed content
 */
export const styleCapitalizedText = (content) => {
  // If content is a string, process it
  if (typeof content === 'string') {
    const words = content.split(/(\s+)/);
    return words.map((word, index) => {
      if (isFullyCapitalized(word)) {
        return (
          <span 
            key={index}
            className="!text-[#D3242A]"
            style={{ fontFamily: "Geogrotesque, sans-serif" }}
          >
            {word}
          </span>
        );
      }
      return word;
    });
  }

  // If content is an array, process each item
  if (Array.isArray(content)) {
    return content.map((item, index) => {
      if (typeof item === 'string') {
        return styleCapitalizedText(item);
      }
      return item;
    });
  }

  // Return the content as is if it's not a string or array
  return content;
}; 